<div *ngIf="!loading && showRustadPostProcessingWarning" class="rustad-warning flex align-items-center mb-3">
  <i class="pi pi-info mr-2" style="color: #F59E0B; font-size: 1.5em;"></i>
  <div>
    <p class="m-0" style="color: #F59E0B; font-size: 1.1em;">{{rustadWarningText}}</p>
    <p class="m-0">The files needed for it are in the "{{rustadPostProcessingFolder}}" folder of the project outputs download.</p>
  </div>
</div>

<app-grid *ngIf="!loading"
  [columnDefs]="columDef"
  [rowData]="rowData"
  [selectedProject]="selectedProject"
/>

<app-loading *ngIf="loading"/>
